import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { environment } from 'src/environments/environment';

// firebase
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';

//materials library
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CdkDrag, DragDropModule } from '@angular/cdk/drag-drop';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatListModule } from '@angular/material/list';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatNativeDateModule } from '@angular/material/core';


import { SideMenuComponent } from './components/menu/side-menu/side-menu.component';
import { MainMenuComponent } from './components/menu/main-menu/main-menu.component';

// main app components
import { AddSpotComponent } from './components/add-spot/add-spot.component';
import { AssignMovesComponent } from './components/assign-moves/assign-moves.component';
import { MovesHistoryComponent } from './components/moves-history/moves-history.component';
import { MovesComponent } from './components/moves/moves.component';
import { TrailersComponent } from './components/trailers/trailers.component';
import { YardViewComponent } from './components/yard-view/yard-view.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { PrivacyPolicyComponent } from './commons/privacy-policy/privacy-policy.component';
import { HomeComponent } from './home/home.component';
import { DownLoadsComponent } from './components/down-loads/down-loads.component';
import { SpotViewComponent } from './components/yard-view/spot-view/spot-view.component';
import { AppComponent } from './app.component';
import { AssignFormComponent } from './components/assign-moves/assign-form/assign-form.component';

//commons
import { ImageIllustrationComponent } from './commons/image-illustration/image-illustration.component';
import { InstructionsComponent } from './commons/instructions/instructions.component';
import { TermsOfServiceComponent } from './commons/terms-of-service/terms-of-service.component';
import { AboutUsComponent } from './commons/about-us/about-us.component';
import { LoadingScreenComponent } from './components/loading-screen/loading-screen.component';
import { ChatBoxComponent } from './commons/chat-box/chat-box.component';
import { ContactComponent } from './commons/contact/contact.component';

//finance
import { CartViewComponent } from './payment/cart-view/cart-view.component';
import { SuccessComponent } from './payment/success/success.component';
import { SubPricingComponent } from './payment/sub-pricing/sub-pricing.component';
import { SettingsComponent } from './payment/settings/settings.component';

//auth
import { LoginComponent } from './auth/login/login.component';
import { RegisterComponent } from './auth/register/register.component';
import { UpdateEmailComponent } from './auth/update-email/update-email.component';
import { AccountDisabledComponent } from './auth/account-disabled/account-disabled.component';
import { EmailVerificationComponent } from './auth/email-verification/email-verification.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { UpdatePasswordComponent } from './auth/update-password/update-password.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { TokenVerificationComponent } from './auth/token-verification/token-verification.component';
import { ReAuthComponent } from './auth/re-auth/re-auth.component';
import { UserManagementComponent } from './auth/user-management/user-management.component';
import { MemberLoginComponent } from './auth/member-login/member-login.component';
import { InstanceComponent } from './auth/instance/instance.component';
//dialog

import { LocationComponent } from './dialogs/location/location.component';
import { MovesReportComponent } from './dialogs/moves-report/moves-report.component';
import { YardReportComponent } from './dialogs/yard-report/yard-report.component';
import { ConfirmationDialogComponent } from './dialogs/confirmation-dialog/confirmation-dialog.component';
import { CreateInstanceDialogComponent } from './dialogs/create-instance-dialog/create-instance-dialog.component';




@NgModule({
  declarations: [
    AppComponent,
    LoadingScreenComponent,
    ChatBoxComponent,
    MainMenuComponent,
    SideMenuComponent,
    YardViewComponent,
    LocationComponent,
    MovesComponent,
    MovesHistoryComponent,
    AssignMovesComponent,
    SpotViewComponent,
    AddSpotComponent,
    AssignFormComponent,
    TrailersComponent,
    ConfirmationDialogComponent,
    CreateInstanceDialogComponent,
    InstructionsComponent,
    ImageIllustrationComponent,
    LoginComponent,
    ForgotPasswordComponent,
    UpdatePasswordComponent,
    UpdateEmailComponent,
    RegisterComponent,
    UserManagementComponent,
    InstanceComponent,
    ResetPasswordComponent,
    TokenVerificationComponent,
    AccountDisabledComponent,
    EmailVerificationComponent,
    ReAuthComponent,
    ErrorPageComponent,
    PrivacyPolicyComponent,
    HomeComponent,
    AboutUsComponent,
    TermsOfServiceComponent,
    DownLoadsComponent,
    SuccessComponent,
    SettingsComponent,
    CartViewComponent,
    SubPricingComponent,
    MovesReportComponent,
    YardReportComponent,
    MemberLoginComponent,
    ContactComponent
  ],
  imports: [
    HttpClientModule,
    ReactiveFormsModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFireModule,
    AngularFirestoreModule,
    MatCheckboxModule,
    MatDialogModule,
    MatInputModule,
    MatTabsModule,
    MatCardModule,
    MatSelectModule,
    MatButtonModule,
    MatChipsModule,
    MatSnackBarModule,
    MatFormFieldModule,
    MatIconModule,
    MatToolbarModule,
    DragDropModule,
    MatRadioModule,
    MatTooltipModule,
    MatListModule,
    MatStepperModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSidenavModule,
    MatMenuModule,
    MatPaginatorModule,
    MatExpansionModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    CdkDrag
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule { }
